<script>
import General from '../../../../resources/frontend/js/mixins/general.vue';
import History from '../quiz/history.vue';

export default {
    mixins: [General, History],

    methods: {
        goToNextStep() {
            const pageStore = this.$store.state.page;

            this.$store.commit('page/setValue', {
                key: 'previousStep',
                value: pageStore.step,
            });

            if (pageStore.step === pageStore.totalSteps - 1) {
                this.dataLayerPush('Form step 1');
            }

            pageStore.step++;
            pageStore.wrapper.setAttribute('data-step', pageStore.step);

            this.updateParameter('data_step', pageStore.step);

            if (!pageStore.wrapper.hasAttribute('data-no-step-scroll')) {
                this.scrollToSelector('body');
            }

            this.dataLayerPush(`Go to step: ${pageStore.step}`);

            this.$nextTick(() => {
                this.$store.commit('cro/runStepChangeEvents', pageStore.step);

                if (document.querySelector(`.step--${pageStore.step} .question`)) {
                    this.$store.commit('page/increasePixelStep', { label: 'Question' });
                    return;
                }

                if (document.querySelector(`.step--${pageStore.step} .loadingscreen`)) {
                    this.$store.commit('page/increasePixelStep', { label: 'Loading' });
                    return;
                }

                if (document.querySelector(`.step--${pageStore.step} #form-wrapper`)) {
                    this.$store.commit('page/increasePixelStep', { label: 'Form' });
                }
            });
        },

        goToPreviousStep(step = 0) {
            const pageStore = this.$store.state.page;
            const quizStore = this.$store.state.quiz;

            this.$store.commit('page/setValue', {
                key: 'previousStep',
                value: pageStore.step,
            });

            if (step === 0) {
                pageStore.step--;
            } else {
                pageStore.step = step;
            }

            if (quizStore.questionCount > quizStore.totalFlowLength) {
                quizStore.questionCount = quizStore.totalFlowLength;
            }

            pageStore.wrapper.setAttribute('data-step', pageStore.step);

            if (!pageStore.wrapper.hasAttribute('data-no-step-scroll')) {
                this.scrollToSelector('body');
            }

            this.$nextTick(() => {
                this.$store.commit('cro/runStepChangeEvents', pageStore.step);

                if (pageStore.step === 1) {
                    if (document.querySelector('.question')) {
                        this.$store.commit('page/decreasePixelStep', { label: 'Question' });
                        return;
                    }

                    this.$store.commit('page/decreasePixelStep', { label: 'Start' });
                    return;
                }

                if (document.querySelector('.loadingscreen')) {
                    this.$store.commit('page/decreasePixelStep', { label: 'Loading' });
                    return;
                }

                if (document.querySelector('#form-wrapper')) {
                    this.$store.commit('page/decreasePixelStep', { label: 'Form' });
                }
            });
        },
    },
};
</script>
